import { useCallback, useEffect, useMemo, useState } from "react";
import { Select, Row, Col, Input, Button, Popconfirm, Modal, Spin } from "antd";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

import { Wrapper } from "./styles";
import { useHistory, useParams } from "react-router-dom";

import { FichaService } from "../../../services/ficha.service";
import getAPPS from "../../../utils/getAppAndGroups";
import { toast } from "react-toastify";
import { useAuth } from "../../../hooks/auth";
import { DetailsUser } from "../../../components/details/user";
import { DetailsAddress } from "../../../components/details/address";
import { DetailsSystem } from "../../../components/details/system";
import { DetailsHigher } from "../../../components/details/higher";
import { DetailsComissaoSip3w } from "../../../components/details/comissaoSip3w";
import { DetailsFiles } from "../../../components/details/files";

const { Option } = Select;
const { TextArea } = Input;

export function InteligenciaCoinFormApproval() {
  const { id } = useParams();
  const { client } = useAuth();
  const { name, cpf } = client;
  const history = useHistory();

  const listApp = useMemo(() => getAPPS(), []);
  const [state, setState] = useState({
    cpf: "",
    nivel: null,
    observacao: null,
    matricula: null,
    nome: null,
    loading: true,
    entidade: {},
  });

  const update = useCallback((value) => {
    setState((prev) => ({ ...prev, ...value }));
  }, []);

  const loadById = useCallback(async () => {
    update({ loading: true });

    try {
      const { data } = await FichaService.getById({ id });
      update({ loading: false, entidade: data, nivel: data.nivel });
    } catch (err) {
      console.log(err);
    } finally {
      //
    }
  }, [update, id]);

  useEffect(() => {
    loadById();
  }, [loadById]);

  const { entidade } = state;

  const validationFields = useCallback(() => {
    if (!state.nivel) {
      toast.error("Preencha o nível");
      return false;
    }

    if (!state.observacao) {
      toast.error("Preencha a Observação");
      return false;
    }

    return true;
  }, [state.nivel, state.observacao]);

  const submitRequest = useCallback(
    async (isAprovado) => {
      if (validationFields()) {
        try {
          update({ loading: true });
          await FichaService.aprovacaoInteligencia({
            id,
            nome: name,
            aprovado: isAprovado,
            cpf,
            nivel: state.nivel,
            observacao: state.observacao,
            orgao: "COIN",
          });
          countDown(isAprovado);
          update({
            cpf: "",
            nivel: null,
            observacao: null,
            matricula: null,
            nome: null,
            loading: true,
            entidade: {},
          });
          history.goBack();
        } catch (err) {
          toast.error("Erro ao salvar, tente novamente!");
        } finally {
          update({ loading: false });
        }
      }
    },
    [
      cpf,
      history,
      id,
      name,
      state.nivel,
      state.observacao,
      update,
      validationFields,
    ]
  );

  function countDown(isAprovado) {
    let secondsToGo = 5;
    // \n Protocolo: ${id}
    const modal = Modal.success({
      title: `${isAprovado ? "Aprovação" : "Reprovação"} salva com sucesso`,
      content: ``,
    });
    const timer = setInterval(() => {
      secondsToGo -= 1;
      modal.update({
        content: `A modal será fechado em ${secondsToGo} segundos.`,
      });
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
    }, secondsToGo * 1000);
  }

  return (
    <Spin spinning={state.loading}>
      <Wrapper>
        <DetailsUser entidade={entidade} />
        <br />
        <DetailsAddress entidade={entidade} />
        <br />
        <DetailsSystem entidade={entidade} />
        <br />
        <DetailsHigher entidade={entidade} />
        <br />
        <DetailsComissaoSip3w entidade={entidade} />
        <br />
        <DetailsFiles entidade={entidade} />
        <br />
        <br />
        <br />

        <div className="ant-descriptions-title">Atualização Nível</div>
        <br />
        {entidade && entidade.sistema && (
          <Row gutter={[16, 16]}>
            <Col span={2}>
              <span>Nível: </span>
            </Col>
            <Col span={6}>
              <Select
                showSearch
                placeholder="Selecione o nível"
                optionFilterProp="children"
                defaultValue={entidade.nivel}
                value={state.nivel}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                onChange={(nivel) => update({ nivel })}
              >
                {listApp
                  .filter(
                    (v) => v.app === entidade.sistema.replace("_", " ")
                  )[0]
                  .groups.map((lista) => {
                    return (
                      <Option key={lista.key} value={lista.name}>
                        {lista.name}
                      </Option>
                    );
                  })}
              </Select>
            </Col>
          </Row>
        )}
        <br />

        <Col span={2}>
          <span>Observação: </span>
        </Col>
        <Col>
          <TextArea
            maxLength={1000}
            rows={4}
            value={state.observacao}
            showCount
            onChange={(e) => update({ observacao: e.target.value })}
          />
        </Col>

        <br />
        <Row justify="end">
          <Popconfirm
            placement="top"
            title={"Deseja realmente reprovar?"}
            onConfirm={() => submitRequest(false)}
            okText="Sim"
            cancelText="Não"
          >
            <Button icon={<CloseCircleOutlined />} danger>
              Reprovar
            </Button>
          </Popconfirm>
          <div className="sizeBoxWidth" />
          <Popconfirm
            placement="top"
            title={"Deseja realmente aprovar?"}
            onConfirm={() => submitRequest(true)}
            okText="Sim"
            cancelText="Não"
          >
            <Button icon={<CheckCircleOutlined />} type="primary">
              Aprovar
            </Button>
          </Popconfirm>
        </Row>
      </Wrapper>
    </Spin>
  );
}
